// extracted by mini-css-extract-plugin
export default {"sectionLayout":"launch_sectionLayout__FPPmo","launchLogo":"launch_launchLogo__tmREW","launchload":"launch_launchload__pszwT","logo":"launch_logo__HzvBm"};